module.exports = __webpack_public_path__ + "media/prepaid-cards/prepaid-1000-with-gift-1a3f918f.png";